// Module
var code = "<md-input-container class=\"mn-datepicker-container\">\r\n    <label></label>\r\n    <md-datepicker mn-date ng-model-options=\"{updateOn: 'blur'}\" />\r\n</md-input-container>";
// Exports
module.exports = code;